<template lang="pug">
  self-layout(v-if="routeState.isMe")
    template(#name)
      self-name
    template(#preferences)
      self-preferences
</template>

<script>
import { injectRouteState } from '@iez/core'

import SelfLayout from './layout/'
import SelfName from './name/'
import SelfPreferences from './preferences/'

export default {
  components: {
    SelfLayout,
    SelfName,
    SelfPreferences
  },

  setup () {
    const routeState = injectRouteState()

    return {
      routeState
    }
  }
}
</script>
